import * as api from "./slack/api";

export interface HeaderCallbacks {
	onBack?: () => void;
	onClose?: () => void;
}

export interface UsersMap {
	[id: string]: api.User;
}

export class SelectedChannel {
	constructor(readonly channelId: string, readonly channelName: string, readonly isMember: boolean, readonly isPrivate: boolean) { }

	/**
	 * Returns an instance representing a case where the channel was NOT selected
	 */
	public static empty(): SelectedChannel {
		return new SelectedChannel("", "", false, false);
	}
}

export const ATTR_ID_SLACK_CHANNELS = "SlackChannels";
